/**
 * Strings of the contribution task kit, FR and EN. Task names are not here:
 * they come from features/contributor-tasks (same labels as the mobile app).
 * Placeholders in braces are filled with `fillCopy`.
 */
export const contributionKitCopy = {
  fr: {
    back: "Retour",
    enterFocusMode: "Passer en plein écran",
    exitFocusMode: "Quitter le plein écran",
    play: "Écouter",
    pause: "Mettre en pause",
    switchTask: "Changer de tâche",
    position: "{current} / {total}",
    progressLabel: "Progression de la session",
    guidelines: "Consignes",
    guidelinesTitle: "Consignes : {task}",
    guidelinesDone: "J'ai compris",
    report: "Signaler",
    reportTitle: "Signaler un problème",
    reportDescription: "À propos de la tâche « {task} ». Votre message part directement à l'équipe qualité.",
    reportReason: "Quel est le problème ?",
    reportDetails: "Précisez (facultatif)",
    reportDetailsPlaceholder: "Décrivez ce qui ne va pas...",
    reportItem: "élément {id}",
    reportSend: "Envoyer le signalement",
    reportCancel: "Annuler",
    reportSent: "Signalement envoyé",
    reportSentDesc: "Merci, l'équipe qualité va l'examiner.",
    reportError: "Le signalement n'a pas pu être envoyé",
    reportErrorDesc: "Vérifiez votre connexion puis réessayez.",
    shortcuts: "Raccourcis clavier",
    keySpace: "Espace",
    keyEnter: "Entrée",
    keyLeft: "Flèche gauche",
    keyRight: "Flèche droite",
    languageLoading: "Chargement des langues...",
    languageEmpty: "Aucune langue disponible",
    setupLanguage: "Langue",
    setupInstructions: "Avant de commencer",
    sessionDoneTitle: "Session terminée",
    sessionDoneContinue: "Continuer",
    sessionDoneHome: "Retour à l'accueil",
  },
  en: {
    play: "Play",
    pause: "Pause",
    back: "Back",
    enterFocusMode: "Enter full screen",
    exitFocusMode: "Exit full screen",
    switchTask: "Switch task",
    position: "{current} / {total}",
    progressLabel: "Session progress",
    guidelines: "Guidelines",
    guidelinesTitle: "Guidelines: {task}",
    guidelinesDone: "Got it",
    report: "Report",
    reportTitle: "Report a problem",
    reportDescription: "About the \"{task}\" task. Your message goes straight to the quality team.",
    reportReason: "What is the problem?",
    reportDetails: "Details (optional)",
    reportDetailsPlaceholder: "Describe what is wrong...",
    reportItem: "item {id}",
    reportSend: "Send report",
    reportCancel: "Cancel",
    reportSent: "Report sent",
    reportSentDesc: "Thank you, the quality team will look into it.",
    reportError: "The report could not be sent",
    reportErrorDesc: "Check your connection and try again.",
    shortcuts: "Keyboard shortcuts",
    keySpace: "Space",
    keyEnter: "Enter",
    keyLeft: "Left arrow",
    keyRight: "Right arrow",
    languageLoading: "Loading languages...",
    languageEmpty: "No language available",
    setupLanguage: "Language",
    setupInstructions: "Before you start",
    sessionDoneTitle: "Session complete",
    sessionDoneContinue: "Continue",
    sessionDoneHome: "Back to home",
  },
} as const;

export type ContributionKitCopy = { [K in keyof (typeof contributionKitCopy)["fr"]]: string };

export type KitLang = "fr" | "en";

export const kitLang = (language: string | undefined | null): KitLang => (language === "en" ? "en" : "fr");

/** Replaces each `{key}` of a template with its value. */
export const fillCopy = (text: string, values: Record<string, string | number>) =>
  Object.entries(values).reduce((out, [key, value]) => out.split(`{${key}}`).join(String(value)), text);
